import React from 'react'
import { useNavigate } from 'react-router'
import { useState } from 'react'
import xmark from '../assets/images/xmark.png'
import searchIcon from '../assets/images/Search.png'
import calendar from '../assets/images/fi_calendar.png'
import downarrow from '../assets/images/icons/downarrow.svg'
import './newTrip.css'
import Counter from './Counter'
import Counter1 from './Counter1'
import CategoryBtns from './CategoryBtns'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import { DatePicker } from 'antd'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css'
import 'react-calendar/dist/Calendar.css'
import './Customcalender.css'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { Box, Button, Dialog, Input, Modal, Slide } from '@mui/material'

import { useSelector, useDispatch } from 'react-redux'

import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  fetchCurrentTripForm,
  updateUser,
  updateMailId,
  updatePhoneNumber,
  updateCurrency,
  updateDateRange,
} from '../redux/features/tripFormSlice'
import AgeSelection from './trips/components/ageSelectionComponent'
import SelectCurrencyModal from './modal/currencyModal'
import { format } from 'date-fns'
import { trip_object } from './tripObjects/empty_trip'
import { days_between } from '../util'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const securrencys = [
  {
    value: '$-US Dollar (USD)',
    label: 'USD',
  },
  {
    value: '₹-Indian Rupee(INR)',
    label: 'INR',
  },
  {
    value: '£ - UK Pound(GBP)',
    label: 'GBP',
  },
  {
    value: 'دإ - United Arab Emirates Dirham(AED)',
    label: 'AED',
  },
  {
    value: 'C$ - Canadian Dollar (CAD)',
    label: 'CAD',
  },
  {
    value: '¥ - Chinese Yuan(CNY)',
    label: 'CNY',
  },
  {
    value: 'HK$ - Hong Kong Dollar(HKD)',
    label: 'HKD',
  },
  {
    value: 'FT-Hungarian Forint(HUF)',
    label: 'HUF',
  },
]

const FormSchema = yup.object().shape({
  tripname: yup.string().required(),
  destination: yup.string().required(),
  rPiker: yup.string().required(),
  email: yup.string().email().required(),
  cosphonu: yup.string().required(),
  securrency: yup.string().required(),
})

export default function NewTrip() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const tripFormData = useSelector(fetchCurrentTripForm)

  const initUser = {
    tripname: tripFormData.tripname ? tripFormData?.tripname : '',
    destination: tripFormData?.destination ? tripFormData?.destination : '',
    securrency: tripFormData?.securrency ? tripFormData?.securrency : '$(USD)',
    cosphonu: tripFormData?.cosphonu ? tripFormData?.cosphonu : '',
    email: tripFormData?.email ? tripFormData?.email : '',
  }

  // const [dates, setDates] = useState(null);
  // const [value, setValue] = useState(null);
  const [user, setUser] = useState(initUser)
  const [open, setOpen] = useState(false)
  const [selectedCurrency, setSelectedCurrency] = useState('')
  const [currencyName, setCurrencyName] = React.useState()
  const [mobileNumber, setMobileNumber] = useState()
  const [value, onChange] = useState([new Date(), new Date()])
  const [adultDefault, setAdultDefault] = useState(2)
  const [adultsCount, setAdultsCount] = useState()

  dayjs.extend(customParseFormat)
  const { RangePicker } = DatePicker
  const disabledDate = (current) => {
    return current && current < dayjs().endOf('day')
  }
  // const disabledDate = (current) => {
  //   if (!dates) {
  //     return false;
  //   }
  //   const tooLate = dates[0] && current.diff(dates[0], "days") > 7;
  //   const tooEarly = dates[1] && dates[1].diff(current, "days") > 7;
  //   return !!tooEarly || !!tooLate;
  // };

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const handleChange = (e, currency) => {
    if (currency) {
      const { name } = e.target
      setUser({ ...user, [name]: currency.label })
      const updatedUser = { ...user, [name]: currency.label }
      dispatch(updateUser(updatedUser))
    } else {
      const { name, value } = e.target

      setUser({ ...user, [name]: value })
      // user.rPiker = user.rPiker.toString();
      const updatedUser = { ...user, [name]: value }
      dispatch(updateUser(updatedUser))
    }
  }

  const handleDateChange = (date, dateString) => {
    user.rPiker = dateString

    setUser({ ...user })
    dispatch(updateUser(user))
  }

  const handleAdultsCount = (val) => {
    setAdultsCount(val)
  }

  const initialValues = {
    tripname: tripFormData.tripname ? tripFormData?.tripname : '',
    destination: tripFormData?.destination ? tripFormData?.destination : '',
    cosphonu: tripFormData?.cosphonu ? tripFormData?.cosphonu : '',
    securrency: tripFormData?.securrency ? tripFormData?.securrency : '$(USD)',
    email: tripFormData?.email ? tripFormData?.email : '',
  }

  const {
    register,
    handleSubmit,
    watch,
    // formState: { errors },
    control,
    formState: { errors, isDirty },
  } = useForm({
    defaultValues: initialValues,
    mode: 'onChange',
    resolver: yupResolver(FormSchema),
  })

  // Submitting the Trip object
  const onSubmit = (data) => {
    console.log('>>>Submit data::', data)
    let final_object = {
      ...trip_object,
      address: { ...trip_object.address }, //need to make a copy at nested level
      properties: { ...trip_object.properties },
      customer_info: { ...trip_object.customer_info },
    }

    final_object.item_id = 'trip_submit1'
    final_object.display_name = data.tripname
    final_object.address.city = data.destination
    final_object.properties.trip_summary.start_date = format(
      new Date(tripFormData.rPiker.startDate),
      'yyyy-MM-dd',
    )
    final_object.properties.trip_summary.end_date = format(
      new Date(tripFormData.rPiker.endDate),
      'yyyy-MM-dd',
    )
    final_object.customer_info.email = data.email
    final_object.customer_info.phone = data.cosphonu
    // alert(JSON.stringify(final_object))
    console.log('>>>Submit data::', final_object)
    final_object.properties.trip_summary.duration_days = days_between(
      format(new Date(tripFormData.rPiker.startDate), 'yyyy-MM-dd'),
      format(new Date(tripFormData.rPiker.endDate), 'yyyy-MM-dd'),
    )
    final_object.properties.base_currency = data.securrency
  }

  const onSearchClick = () => {
    dispatch(updateUser(user))
    // alert(JSON.stringify(data));
    navigate('searchin')
  }

  const handleMailId = (e) => {
    dispatch(updateMailId(e.target.value))
  }

  const handlePhoneNumber = (e) => {
    dispatch(updatePhoneNumber(e.target.value))
  }

  const handleChangeCurr = (e) => {
    dispatch(updateCurrency(e.target.value))
  }

  const tripname = watch('tripname')
  const destination = watch('destination')
  const rPiker = watch('rPiker')
  const email = watch('email')
  const cosphonu = watch('cosphonu')
  const categoriesBtns = watch('categoryBtns')
  const securrency = watch('securrency')

  const isValid = tripname && destination && rPiker && securrency

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="new_trip_container" style={{ paddingTop: '20px' }}>
        <div className="create-part">
          <img
            onClick={() => navigate(-1)}
            className="xmark"
            src={xmark}
            alt="xmark"
          />
          <p className="title2" style={{ marginLeft: '22px' }}>
            Create new trip
          </p>
        </div>

        <div className="trip-input">
          <label
            className="body4"
            style={{ color: 'var(--gray80)', margin: '0' }}
          >
            Trip Name
          </label>

          <input
            type="text"
            className="input-trip"
            name="tripname"
            placeholder="Add trip name"
            {...register('tripname', { onChange: (e) => handleChange(e) })}
          />
        </div>

        <div
          className="trip-input"
          style={{ position: 'relative', display: 'flex' }}
        >
          <label
            className="body4"
            style={{ color: 'var(--gray80)', margin: '0 0 10px' }}
          >
            Search destination
          </label>
          <div
            className="serch-input"
            style={{ width: '100%', height: '47px' }}
          >
            <img
              src={searchIcon}
              alt="search"
              style={{ paddingLeft: '16px' }}
            />
            <input
              onClick={() => onSearchClick()}
              className="search-inp"
              name="destination"
              {...register('destination')}
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search destination"
            />
          </div>
        </div>
        <div className="trip-input">
          <label
            className="body4"
            style={{ color: 'var(--gray80)', margin: '0' }}
          >
            Select date range
          </label>
          <div
            className="serch-input"
            style={{ width: '100%', height: '47px', marginTop: '10px' }}
          >
            <div className="calendar-icon">
              <img
                src={calendar}
                alt="calendar"
                style={{ width: '20px', height: '20px' }}
                onClick={() => navigate('date-range')}
              />
            </div>
            <input
              value={
                tripFormData?.rPiker?.startDate
                  ? tripFormData?.rPiker?.dateString
                  : []
              }
              className="search-inp"
              name="rPiker"
              {...register('rPiker')}
              sx={{ ml: 1, flex: 1 }}
              placeholder="Select date range"
            />
            {/* <DateRangePicker onChange={onChange} value={value} style={{ml: 1, flex: 1 }} placeholder="Select date range"/> */}
          </div>
          <div className="Date-range-picker search-inp"></div>

          {/* <RangePicker
            // value={dates || value}
            disabledDate={disabledDate}
            // onCalendarChange={(val) => setDates(val)}
            // onChange={(val) => setValue(val)}
            name="rPiker"
            {...register("rPiker")}
          />  */}
        </div>

        <div className="count-days">
          <p className="body2" style={{ color: 'var(--gray100)' }}>
            Number of days
          </p>
          <Counter days={'days'} />
        </div>

        <p
          className="body4"
          style={{ margin: '0 0 1rem', color: 'var(--gray80)' }}
        >
          Travellers
        </p>

        <div className="count" style={{ marginTop: '1rem' }}>
          <p className="body2" style={{ color: 'var(--gray100)' }}>
            Adults
          </p>
          <Counter
            adultDefault={adultDefault}
            handleAdultsCount={handleAdultsCount}
          />
        </div>

        <div className="count" style={{ marginBottom: '30px' }}>
          <p className="body2" style={{ color: 'var(--gray100)' }}>
            Children (Age 0 -17){' '}
          </p>
          <Counter1 />
        </div>
        <div>
          <AgeSelection />
        </div>

        <div className="trip-input">
          <label
            className="body4"
            style={{ color: 'var(--gray80)', margin: '0' }}
          >
            Customer mail id
          </label>

          <input
            className="input-trip"
            type="email"
            name="email"
            placeholder="name@gmail.com"
            {...register('email', { onChange: (e) => handleChange(e) })}
          />
        </div>

        <div className="trip-input">
          <label
            className="body4"
            style={{ color: 'var(--gray80)', margin: '0' }}
          >
            Customer phone number
          </label>

          <input
            className="input-trip"
            type="text"
            name="cosphonu"
            placeholder="Add number"
            {...register(
              'cosphonu',
              { onChange: (e) => handleChange(e) },
              {
                pattern: {
                  value: /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
                  message: 'Invalid phone number',
                },
              },
              // {
              //   min: {
              //     value: 10,
              //     message: "Min Length of Mobile number is 10",
              //   },
              //   max: {
              //     value: 10,
              //     message: "Max Length of Mobile number is 10",
              //   },
              // },
            )}
            // onChange={(e) => setMobileNumber(e.target.value)}
          />
        </div>
        <div className="trip-input">
          <label
            className="body4"
            style={{ color: 'var(--gray80)', margin: '0' }}
          >
            Select currency
          </label>

          {/* <controller
              control={control}
              style={{ height: "30px", width: "200px" }}
              select
            >
              <select
                style={{
                  margingLeft: "10px",
                  height: "46px",
                  width: "100%",
                  border: "none",
                  background: "none",
                  
                }}
                id="outlined-select-state"
                fullWidth
                name="securrency"
                {...register("securrency", {onChange: (e) => handleChange(e)})}
              >
                {securrencys.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}

              </select>
            </controller> */}

          <div className="currency-container">
            <input
              type="text"
              className="currency-input"
              name="securrency"
              value={
                tripFormData?.securrency ? tripFormData?.securrency : '$(USD)'
              }
              onClick={handleOpen}
              {...register('securrency')}
            />
            <img
              src={downarrow}
              alt="downarrow"
              className="downarrow"
              onClick={handleOpen}
            />
          </div>

          <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            fullWidth={false}
            maxWidth="lg"
          >
            <div className="currencyPosition">
              <SelectCurrencyModal
                handleClose={handleClose}
                selectedCurrency={setSelectedCurrency}
                handleChange={handleChange}
              />
            </div>
          </Dialog>
        </div>

        <div className="trip-category">
          <label
            className="body4"
            style={{ color: 'var(--gray80)', margin: '0' }}
          >
            Trip categories
          </label>
          <br />
          <CategoryBtns name="categoryBtns" {...register('categoryBtns')} />
        </div>
        <br />
      </div>
      <footer className="create-button">
        <input
          className="btn-create"
          variant="contained"
          style={{ width: '90%' }}
          type="submit"
          fullWidth
          disabled={!isDirty || !isValid}
          // onClick={() => navigate('overview')}
          label="create"
          value="Create"
        ></input>
      </footer>
    </form>
  )
}
